document.addEventListener('click', (event) => {
  const language = event.target.closest('[data-ms-language]');
  if (language) {
    language.form.querySelector('[name="language_code"]').value = language.dataset.msLanguage;
    const returnTo = language.form.querySelector('[name="return_to"]');
    if (returnTo && language.dataset.msReturnTo) returnTo.value = language.dataset.msReturnTo;
  }
  const button = event.target.closest('[data-ms-model]');
  if (!button) return;
  const showcase = button.closest('[data-ms-showcase]');
  if (!showcase) return;
  showcase.querySelectorAll('[data-ms-model]').forEach((item) => {
    item.setAttribute('aria-pressed', String(item === button));
  });
  showcase.querySelectorAll('[data-ms-panel]').forEach((panel) => {
    panel.hidden = panel.dataset.msPanel !== button.dataset.msModel;
    if (!panel.hidden) {
      const image = panel.querySelector('img');
      if (image) image.loading = 'eager';
    }
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.ms-search[open]').forEach((element) => {
    element.open = false;
    element.querySelector('summary')?.focus();
  });
});



const languageForm = document.querySelector('[data-ms-default-language]');
if (languageForm) {
  const key = 'maneti-arabic-default-attempt';
  try {
    if (!sessionStorage.getItem(key)) {
      sessionStorage.setItem(key, '1');
      languageForm.requestSubmit();
    }
  } catch { /* Darija locale strings remain available without browser storage. */ }
}


// Demonstration only: these coordinates never read a customer's controller.
if (!customElements.get('maneti-drift-comparison')) {
  class ManetiDriftComparison extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.paused = false;
      this.elapsed = 0;
      this.lastValuesTime = -1;
      this.visible = false;
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.pauseButton = this.querySelector('[data-drift-pause]');
      this.sticks = [...this.querySelectorAll('[data-drift-stick]')].map(panel => ({
        panel,
        side: panel.dataset.driftStick,
        line: panel.querySelector('[data-drift-line]'),
        point: panel.querySelector('[data-drift-point]'),
        x: panel.querySelector('[data-drift-x]'),
        y: panel.querySelector('[data-drift-y]'),
        state: panel.querySelector('[data-drift-state]')
      }));
      this.driftingStick = this.sticks.find(stick => stick.side === 'drift');
      this.sticks.forEach(stick => {
        const active = stick.side === 'drift';
        stick.panel.dataset.active = String(active);
        stick.state.textContent = active ? this.dataset.activeLabel : this.dataset.centredLabel;
        if (!active) {
          stick.point.setAttribute('cx', '80');
          stick.point.setAttribute('cy', '80');
          stick.line.setAttribute('x2', '80');
          stick.line.setAttribute('y2', '80');
          stick.x.textContent = '0.0000';
          stick.y.textContent = '0.0000';
        }
      });
      this.onClick = event => {
        if (event.target.closest('[data-drift-pause]')) {
          this.paused = !this.paused;
          this.pauseButton.setAttribute('aria-pressed', String(this.paused));
          this.pauseButton.textContent = this.paused ? this.pauseButton.dataset.play : this.pauseButton.dataset.pause;
          this.render(true);
          this.syncMotion();
        }
      };
      this.onMotionChange = () => { this.render(true); this.syncMotion(); };
      this.onVisibilityChange = () => this.syncMotion();
      this.addEventListener('click', this.onClick);
      this.motionPreference.addEventListener('change', this.onMotionChange);
      document.addEventListener('visibilitychange', this.onVisibilityChange);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries.some(entry => entry.isIntersecting);
        this.syncMotion();
      });
      this.observer.observe(this);
      this.setAttribute('data-ready', '');
      this.render(true);
    }

    sample(seconds) {
      const phase = seconds * Math.PI * 2;
      const radial = 0.55
        + Math.sin(phase * 7.3) * 0.14
        + Math.sin(phase * 11.1) * 0.08
        + Math.sin(phase * 3.4) * 0.035;
      const lateral = Math.sin(phase * 9.1) * 0.018
        + Math.sin(phase * 5.3) * 0.01;
      return {
        x: -(radial + lateral) * Math.SQRT1_2,
        y: -(radial - lateral) * Math.SQRT1_2
      };
    }

    render(updateValues = false) {
      const stick = this.driftingStick;
      if (!stick) return;
      const { x, y } = this.sample(this.elapsed);
      const px = (80 + x * 63).toFixed(2);
      const py = (80 + y * 63).toFixed(2);
      stick.point.setAttribute('cx', px);
      stick.point.setAttribute('cy', py);
      stick.line.setAttribute('x2', px);
      stick.line.setAttribute('y2', py);
      const opacity = Math.abs(x) > 0.08 ? '1' : '0';
      if (stick.line.style.opacity !== opacity) stick.line.style.opacity = opacity;
      if (updateValues) {
        stick.x.textContent = x.toFixed(4);
        stick.y.textContent = y.toFixed(4);
        this.lastValuesTime = this.elapsed;
      }
    }

    syncMotion() {
      cancelAnimationFrame(this.frame);
      this.frame = undefined;
      this.lastTime = undefined;
      this.lastPaint = undefined;
      const moving = this.visible && !this.paused && !this.motionPreference.matches && !document.hidden;
      this.dataset.moving = String(moving);
      if (!moving) return;
      const tick = now => {
        if (this.lastTime !== undefined) this.elapsed += Math.min((now - this.lastTime) / 1000, 0.1);
        this.lastTime = now;
        // Draw at most 30 times a second, independent of 60/120/144 Hz displays.
        if (this.lastPaint === undefined || now - this.lastPaint >= 1000 / 30 - 0.5) {
          this.render(this.elapsed - this.lastValuesTime >= 0.1);
          this.lastPaint = now;
        }
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.removeEventListener('click', this.onClick);
      this.motionPreference?.removeEventListener('change', this.onMotionChange);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      this.initialized = false;
    }
  }
  customElements.define('maneti-drift-comparison', ManetiDriftComparison);
}




function applyManetiCopyPolish() {
  const target = document.body;
  if (!target) return;
  const blocked = 'script,style,noscript,textarea,select,option,svg,canvas,pre,code,[contenteditable],.ms-stick-drift';
  const token = /(\bDrift\b)/gi;
  const needsEdit = /Drift|\u0651|عييتي/i;
  const pending = new Set();
  function rewrite(node) {
    if (!node || !node.parentElement || node.parentElement.closest(blocked)) return;
    let content = node.nodeValue;
    if (!needsEdit.test(content)) return;
    content = content.replace(/\u0651/g, '').replace(/عييتي/g, 'عيت');
    if (!/\bDrift\b/i.test(content) || !document.documentElement.lang.toLowerCase().startsWith('ar') || !node.parentElement.closest('.ms-hero--comparison .ms-hero__copy, .ms-shop--first h1')) {
      if (node.nodeValue !== content) node.nodeValue = content;
      return;
    }
    const fragment = document.createDocumentFragment();
    let last = 0;
    for (const match of content.matchAll(token)) {
      if (match.index > last) fragment.append(document.createTextNode(content.slice(last, match.index)));
      const highlighted = document.createElement('span');
      highlighted.className = 'ms-stick-drift';
      highlighted.setAttribute('dir', 'ltr');
      highlighted.textContent = match[0];
      fragment.append(highlighted);
      last = match.index + match[0].length;
    }
    if (last < content.length) fragment.append(document.createTextNode(content.slice(last)));
    node.replaceWith(fragment);
  }
  function inspect(scope) {
    if (!scope) return;
    if (scope.nodeType === Node.TEXT_NODE) { rewrite(scope); return; }
    if (scope.nodeType !== Node.ELEMENT_NODE || scope.matches(blocked)) return;
    const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (needsEdit.test(node.nodeValue) && !node.parentElement.closest(blocked)) nodes.push(node);
    }
    nodes.forEach(rewrite);
  }
  inspect(target);
  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      const items = [...pending];
      pending.clear();
      items.forEach(inspect);
    });
  }
  const observer = new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'characterData') {
        if (needsEdit.test(record.target.nodeValue || '')) pending.add(record.target);
      } else {
        for (const node of record.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.TEXT_NODE) pending.add(node);
        }
      }
    }
    if (pending.size) schedule();
  });
  observer.observe(target, {subtree:true,childList:true,characterData:true});
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', applyManetiCopyPolish, {once:true});
} else {
  applyManetiCopyPolish();
}


/* Draggable WhatsApp contact: stays on the physical right edge in AR/FR/EN. */
function initManetiWhatsappDrag() {
  const link = document.querySelector('a.ms-whatsapp[data-ms-draggable]');
  if (!link || link.dataset.msDragReady === 'true') return;
  link.dataset.msDragReady = 'true';

  // On mobile stay icon-only even at page load, so product content is readable.
  const syncWhatsAppCompact = () => {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    link.classList.toggle('is-compact', isMobile || window.scrollY > 60);
  };
  syncWhatsAppCompact();
  window.addEventListener('scroll', syncWhatsAppCompact, {passive:true});
  window.addEventListener('resize', syncWhatsAppCompact, {passive:true});


  const storageKey = 'maneti-whatsapp-vertical-position-v2';
  const clampY = value => {
    const minY = 68;
    const maxY = Math.max(minY, window.innerHeight - link.offsetHeight - 84);
    return Math.min(maxY, Math.max(minY, value));
  };
  const positionY = top => {
    link.style.top = Math.round(clampY(top)) + 'px';
    link.style.bottom = 'auto';
  };

  try {
    const saved = window.localStorage.getItem(storageKey);
    if (saved !== null && Number.isFinite(Number(saved))) positionY(Number(saved));
  } catch (_error) {
    // Storage disabled: dragging still works for the current page.
  }

  let pointerId = null;
  let originY = 0;
  let originTop = 0;
  let moved = false;
  let ignoreClickUntil = 0;

  link.addEventListener('pointerdown', event => {
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    pointerId = event.pointerId;
    originY = event.clientY;
    originTop = link.getBoundingClientRect().top;
    moved = false;
    try { link.setPointerCapture(event.pointerId); } catch (_error) {}
  });

  link.addEventListener('pointermove', event => {
    if (event.pointerId !== pointerId) return;
    const delta = event.clientY - originY;
    if (!moved && Math.abs(delta) < 9) return;
    moved = true;
    link.classList.add('is-dragging');
    positionY(originTop + delta);
  });

  const stopDrag = event => {
    if (pointerId === null || event.pointerId !== pointerId) return;
    pointerId = null;
    if (moved) {
      ignoreClickUntil = Date.now() + 500;
      try {
        window.localStorage.setItem(storageKey, String(Math.round(link.getBoundingClientRect().top)));
      } catch (_error) {}
    }
    moved = false;
    link.classList.remove('is-dragging');
  };
  link.addEventListener('pointerup', stopDrag);
  link.addEventListener('pointercancel', stopDrag);
  link.addEventListener('click', event => {
    if (Date.now() < ignoreClickUntil) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  });
  window.addEventListener('resize', () => {
    if (link.style.top) positionY(Number.parseFloat(link.style.top));
  }, {passive:true});
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initManetiWhatsappDrag, {once:true});
} else {
  initManetiWhatsappDrag();
}
